import { CSkeleton } from "./CSkeleton"

export const CSkeletonTable = () => {

    return (
        <div className=" w-full flex flex-col">
            <div className=" w-full h-[50px] rounded-[10px] my-[10px] overflow-hidden">
                <CSkeleton />
            </div>

            {[0, 0, 0, 0, 0, 0, 0].map((item: any, index: number) =>
                <div className=" w-full h-[80px] rounded-[10px] my-[10px] overflow-hidden">
                    <CSkeleton />
                </div>
            )}
        </div>
    )
}
